// extracted by mini-css-extract-plugin
export default {"tabHeader":"tabHeader_d8Eh6","left":"left_XzDEE","right":"right_Q9kRI"};